import { useEffect, useState } from 'react';
import { Row } from 'reactstrap';
import Toast from '../../helpers/Toast';
import { GetAssistanceByDocumentDTO } from '../../models/Assistance/GetAssistanceByDocumentDTO';
import { GetDocNumberDTO } from '../../models/Assistance/GetDocNumberDTO';
import { ClientDTO } from '../../models/Client/ClientDTO';
import { EquipmentDTO } from '../../models/Equipment/EquipmentDTO';
import { EditScheduleDTO } from '../../models/Scheduler/EditScheduleDTO';
import { AssistanceService } from '../../services/AssistanceService';
import ClientEquipmentBidirecional, { SelectItemsProps } from '../ClientEquipmentBidirecional/ClientEquipmentBidirecional';
import SearchSelectComponent from '../SearchSelectComponent';
import { useNavigate } from 'react-router-dom';
import { AssistanceUtilitiesWithNavigate } from '../../AssistanceUtilities';
import { useAuth } from '../../context/AuthContext';
import ButtonComponent from '../ButtonComponent';
import { useIntl } from 'react-intl';
import InputComponent from '../InputComponent';

type EditSchedulerFirstTabProps = {
    scheduleDTO: EditScheduleDTO;
    setScheduleDTO: React.Dispatch<React.SetStateAction<EditScheduleDTO>>;

    onClose: () => void;
};

function EditSchedulerFirstTab(props: EditSchedulerFirstTabProps) {

    const assistanceService = new AssistanceService();

    const navigate = useNavigate();
    const assistanceUtilities = AssistanceUtilitiesWithNavigate(navigate);
    const { preferedView } = useAuth();

    const intl = useIntl();


    const [isActiveProjectModule, setIsActiveProjectModule] = useState<boolean>(false);
    const [projectSelected, setProjectSelected] = useState<SelectItemsProps | null>(null);
    const [clientSelected, setClientSelected] = useState<SelectItemsProps | null>(
        props?.scheduleDTO?.clientErpId ? { value: props.scheduleDTO.clientErpId, label: props.scheduleDTO.clientName || '' } : null
    );
    const [serialNumberSelected, setSerialNumberSelected] = useState<SelectItemsProps | null>(
        props.scheduleDTO.equipmentErpId ? { value: props.scheduleDTO.equipmentErpId, label: props.scheduleDTO.equipmentSerialNumber || '' } : null
    );
    const [equipment, setEquipment] = useState<EquipmentDTO>({
        brand: props.scheduleDTO.equipmentBrand || '',
        model: props.scheduleDTO.equipmentModel || '',
        sku: props.scheduleDTO.equipmentSku || '',
    } as EquipmentDTO);
    const [isSearchEquipmentLoading, setIsSearchEquipmentLoading] = useState<boolean>(false);
    const [carPlateSelected, setCarPlateSelected] = useState<SelectItemsProps | null>(
        props.scheduleDTO.equipmentErpId ? { value: props.scheduleDTO.equipmentErpId, label: props.scheduleDTO.equipmentCarPlate || '' } : null
    );
    const [assistanceSelected, setAssistanceSelected] = useState<SelectItemsProps | null>(
        props.scheduleDTO.assistanceId ? { value: props.scheduleDTO.assistanceId.toString(), label: props.scheduleDTO.assistanceName || '' } : null
    );
    const [assistancesList, setAssistancesList] = useState<GetAssistanceByDocumentDTO[]>([]);
    const [observations, setObservations] = useState<string>(props.scheduleDTO.observations || '');

    const GetAssistance = async (valueAssistance: string): Promise<SelectItemsProps[]> => {
        if (isNaN(Number(valueAssistance))) {
            Toast.Show("info", "A pesquisa apenas aceita números do documento");
            return [];
        }

        var docNumber: GetDocNumberDTO = { docNumber: Number(valueAssistance) };
        const response = await assistanceService.GetAssistanceIdByDoc(docNumber);

        if (response.success === false || response.obj === null) {
            Toast.Show("error", response.message);
        }

        const list: SelectItemsProps[] = [];
        response.obj?.forEach((element: any) => {
            var item: SelectItemsProps = {
                value: element.id,
                label: `${element.docType} ${element.serie} ${element.number}`,
                data: element,
            };
            list.push(item);
        });
        setAssistancesList(response.obj || []);
        return list;
    };

    useEffect(() => {
        props.setScheduleDTO({
            ...props.scheduleDTO,
            clientErpId: equipment?.client?.erpId ?? (props.scheduleDTO.clientErpId || null),
            clientName: equipment?.client?.name ?? (props.scheduleDTO.clientName || null),
            equipmentErpId: equipment?.erpId ?? (props.scheduleDTO.equipmentErpId || null),
            equipmentCarPlate: equipment?.carPlate ?? (props.scheduleDTO.equipmentCarPlate || null),
            equipmentSerialNumber: equipment?.serialNumber ?? (props.scheduleDTO.equipmentSerialNumber || null),
            equipmentBrand: equipment?.brand ?? (props.scheduleDTO.equipmentBrand || null),
            equipmentModel: equipment?.model ?? (props.scheduleDTO.equipmentModel || null),
            equipmentSku: equipment?.sku ?? (props.scheduleDTO.equipmentSku || null),
            observations: observations ?? ''
        });
    }, [clientSelected, serialNumberSelected, carPlateSelected, observations]);

    return (
        <div>
            <Row
                style={{
                    margin: "5% 0% 0% 0%",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <SearchSelectComponent
                    xl={assistanceSelected ? 9 : 12}
                    lg={assistanceSelected ? 9 : 12}
                    md={assistanceSelected ? 9 : 12}
                    sm={12}
                    xs={12}
                    label={"Assistência"}
                    loadOptions={GetAssistance}
                    onChange={(assistance: SelectItemsProps | null) => {
                        if (assistance === null) {
                            setAssistanceSelected(null);
                            setClientSelected(null);
                            setSerialNumberSelected(null);
                            setEquipment({
                                id: 0,
                                erpId: '',
                                name: '',
                                carPlate: '',
                                serialNumber: '',
                                brand: '',
                                model: '',
                                sku: '',
                                hasDataSheet: null,
                                client: {} as ClientDTO,
                            });
                            setCarPlateSelected(null);
                            props.setScheduleDTO({
                                ...props.scheduleDTO,
                                assistanceId: null,
                                assistanceName: '',
                                clientErpId: null,
                                clientName: '',
                                equipmentErpId: null,
                                equipmentCarPlate: '',
                                equipmentSerialNumber: '',
                                equipmentBrand: '',
                                equipmentModel: '',
                                equipmentSku: ''
                            });
                        } else {
                            const selectedAssistance = assistancesList.find(a => a.id === assistance.value);
                            if (selectedAssistance) {
                                setAssistanceSelected(assistance);
                                setClientSelected({
                                    value: selectedAssistance.clientErpId || '',
                                    label: selectedAssistance.clientName || ''
                                });
                                setSerialNumberSelected({
                                    value: selectedAssistance.equipmentErpId || '',
                                    label: selectedAssistance.equipmentSerialNumber || ''
                                });
                                setEquipment({
                                    id: 0,
                                    erpId: selectedAssistance.equipmentErpId || '',
                                    name: selectedAssistance.equipmentSerialNumber || '',
                                    carPlate: selectedAssistance.equipmentCarPlate || '',
                                    serialNumber: selectedAssistance.equipmentSerialNumber || '',
                                    brand: selectedAssistance.equipmentBrand || '',
                                    model: selectedAssistance.equipmentModel || '',
                                    sku: selectedAssistance.equipmentSku || '',
                                    hasDataSheet: null,
                                    client: {} as ClientDTO,
                                });
                                setCarPlateSelected({
                                    value: selectedAssistance.equipmentErpId || '',
                                    label: selectedAssistance.equipmentCarPlate || ''
                                });
                                props.setScheduleDTO({
                                    ...props.scheduleDTO,
                                    assistanceId: Number(assistance.value),
                                    assistanceName: `${selectedAssistance.docType} ${selectedAssistance.serie} ${selectedAssistance.number}`,
                                    clientErpId: selectedAssistance.clientErpId || null,
                                    clientName: selectedAssistance.clientName || '',
                                    equipmentErpId: selectedAssistance.equipmentErpId || null,
                                    equipmentCarPlate: selectedAssistance.equipmentCarPlate || '',
                                    equipmentSerialNumber: selectedAssistance.equipmentSerialNumber || '',
                                    equipmentBrand: selectedAssistance.equipmentBrand || '',
                                    equipmentModel: selectedAssistance.equipmentModel || '',
                                    equipmentSku: selectedAssistance.equipmentSku || ''
                                });
                            }
                        }
                    }}
                    value={assistanceSelected}
                    style={{ width: "100%" }}
                />

                {assistanceSelected && (
                    <ButtonComponent
                        text={intl.formatMessage({ id: "Common.Buttons.NavigateToAssistance" })}
                        onClick={() => assistanceUtilities.NavigateToAssistanceDetails(Number(assistanceSelected?.value), preferedView)}
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    />
                )}
            </Row>

            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <ClientEquipmentBidirecional
                    isActiveProjectModule={isActiveProjectModule}
                    projectSelected={projectSelected}
                    clientSelected={clientSelected}
                    setClientSelected={setClientSelected}
                    serialNumberSelected={serialNumberSelected}
                    setSerialNumberSelected={setSerialNumberSelected}
                    equipment={equipment}
                    setEquipment={setEquipment}
                    isSearchEquipmentLoading={isSearchEquipmentLoading}
                    setIsSearchEquipmentLoading={setIsSearchEquipmentLoading}
                    isActiveSearchByCarPlate={true}
                    carPlateSelected={carPlateSelected}
                    setCarPlateSelected={setCarPlateSelected}
                    disableSoftwareFields={true}
                />
            </Row>

            <Row
                style={{
                    margin: "3% 0% 0% 0%",
                    padding: "0px",
                }}
            >
                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={observations}
                    label={"Observações do Agendamento"}
                    readOnly={false}
                    onChange={(t: string) => {
                        setObservations(t);
                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            observations: t
                        });
                    }}
                    rows={4}
                />
            </Row>
        </div>
    );
}

export default EditSchedulerFirstTab;